import { z } from 'zod/v4';

export type CalculationType = z.infer<typeof calculationTypeSchema>;
export const calculationTypeSchema = z.enum([
  'First',
  'Last',
  'FirstNumber',
  'LastNumber',
  'Mean',
  'Sum',
  'Min',
  'Max',
]);
